import React from "react";

import { useIdle } from "~/tools/use-idle";

interface Props {
	fallback: React.ReactNode;
	children: React.ReactNode;
}

export const Idle = ({ fallback, children }: Props): React.JSX.Element => {
	const enabled = useIdle(() => true, [], false);

	if (!enabled) {
		return <>{fallback}</>;
	}

	return <>{children}</>;
};
